import { useState, useEffect } from 'react'
// PWAProvider gere aussi le cas iOS, que l'ancien hook ignorait.
import { usePWA } from './PWAInstall'

const DISMISSED_KEY = 'pwa-dismissed'

export default function PWAInstallBanner() {
  const { installable: canInstall, install } = usePWA()
  const [dismissed, setDismissed] = useState(false)
  const [isMobile, setIsMobile]   = useState(false)

  useEffect(() => {
    setDismissed(localStorage.getItem(DISMISSED_KEY) === '1')
    setIsMobile(window.innerWidth <= 768)
    const onResize = () => setIsMobile(window.innerWidth <= 768)
    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  }, [])

  const handleDismiss = () => {
    localStorage.setItem(DISMISSED_KEY, '1')
    setDismissed(true)
  }

  if (!canInstall || dismissed || !isMobile) return null

  return (
    <div
      role="banner"
      aria-label="Installer l'application ABBusiness"
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        padding: '14px 16px',
        background: '#0d1b3e',
        borderTop: '1px solid rgba(0, 61, 165, 0.4)',
        boxShadow: '0 -4px 24px rgba(0, 0, 0, 0.4)',
      }}
    >
      {/* Phone icon */}
      <span
        aria-hidden="true"
        style={{ fontSize: '24px', flexShrink: 0, lineHeight: 1 }}
      >
        📲
      </span>

      {/* Text */}
      <div style={{ flex: 1, minWidth: 0 }}>
        <p style={{
          margin: 0,
          fontSize: '13px',
          fontWeight: 600,
          color: '#ffffff',
          lineHeight: 1.3,
        }}>
          Installer l&apos;app ABBusiness
        </p>
        <p style={{
          margin: '2px 0 0',
          fontSize: '11px',
          color: 'rgba(255,255,255,0.6)',
          lineHeight: 1.3,
        }}>
          Accès rapide, expérience optimale
        </p>
      </div>

      {/* Install button */}
      <button
        onClick={install}
        style={{
          flexShrink: 0,
          padding: '8px 16px',
          background: '#003DA5',
          color: '#ffffff',
          border: 'none',
          borderRadius: '8px',
          fontSize: '13px',
          fontWeight: 700,
          cursor: 'pointer',
          whiteSpace: 'nowrap',
          letterSpacing: '0.01em',
        }}
      >
        Installer
      </button>

      {/* Dismiss button */}
      <button
        onClick={handleDismiss}
        aria-label="Fermer"
        style={{
          flexShrink: 0,
          width: '28px',
          height: '28px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'transparent',
          color: 'rgba(255,255,255,0.5)',
          border: 'none',
          borderRadius: '50%',
          fontSize: '18px',
          cursor: 'pointer',
          lineHeight: 1,
          padding: 0,
        }}
      >
        ×
      </button>
    </div>
  )
}
